import { render, staticRenderFns } from "./UniversalDialog.vue?vue&type=template&id=3ecc68ea&"
import script from "./UniversalDialog.vue?vue&type=script&lang=js&"
export * from "./UniversalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports